import { p } from "./_helpers";

const education = {
 slug: "education",
 path: "/secteurs/education",
 hero: {
 image: "/photos/sector-education-hero.jpg",
 alt: p("Éducation et formation professionnelle en Afrique de l'Ouest", "Education and vocational training in West Africa", "Educação e formação profissional na África Ocidental"),
 breadcrumb: p("Éducation", "Education", "Educação"),
 title: p("Investir dans l'éducation.", "Investing in education.", "Investir na educação."),
 subtitle: p(
 "Écoles bilingues, formation professionnelle, universités techniques, ed-tech : préparer la génération qui bâtira la Guinée-Bissau.",
 "Bilingual schools, vocational training, technical universities, ed-tech: preparing the generation that will build Guinea-Bissau.",
 "Escolas bilingues, formação profissional, universidades técnicas, ed-tech: preparar a geração que construirá a Guiné-Bissau."
 ),
 },
 seo: {
 title: p(
 "Investir dans l'éducation en Guinée-Bissau | NANDA SÁ",
 "Investing in education in Guinea-Bissau | NANDA SÁ",
 "Investir na educação na Guiné-Bissau | NANDA SÁ"
 ),
 description: p(
 "Éducation, formation professionnelle, écoles bilingues, universités techniques, ed-tech : le panorama d'un secteur clé pour l'avenir de la Guinée-Bissau.",
 "Education, vocational training, bilingual schools, technical universities, ed-tech: the panorama of a key sector for the future of Guinea-Bissau.",
 "Educação, formação profissional, escolas bilingues, universidades técnicas, ed-tech: o panorama de um sector-chave para o futuro da Guiné-Bissau."
 ),
 keywords: "éducation Guinée-Bissau, formation professionnelle Guinée-Bissau, école bilingue Bissau, université ed-tech Afrique de l'Ouest, formation métiers",
 },
 presentation: {
 title: p("La jeunesse comme actif stratégique.", "Youth as a strategic asset.", "A juventude como activo estratégico."),
 paragraphs: p(
 [
 "Plus de 45 % de la population de la Guinée-Bissau et près de 60 % de celle de Guinée-Bissau ont moins de 25 ans. Cette réalité démographique, souvent perçue comme un défi, est en réalité l'un des plus grands actifs stratégiques de la région, à condition d'y investir avec méthode et vision.",
 "Écoles bilingues (français-portugais-anglais), centres de formation aux métiers de demain (numérique, énergie, agroalimentaire, tourisme), universités techniques et plateformes ed-tech : le champ est vaste et encore peu structuré. C'est un secteur où l'impact social se conjugue naturellement avec la rentabilité de long terme.",
 ],
 [
 "More than 45% of Guinea-Bissau's population and nearly 60% of Guinée-Bissau's are under 25. This demographic reality, often perceived as a challenge, is actually one of the region's greatest strategic assets, provided that we invest with method and vision.",
 "Bilingual schools (French-Portuguese-English), training centres for tomorrow's trades (digital, energy, agri-food, tourism), technical universities and ed-tech platforms: the field is vast and still lightly structured. It is a sector where social impact naturally combines with long-term profitability.",
 ],
 [
 "Mais de 45 % da população da Guiné-Bissau e cerca de 60 % da da Guiné-Bissau tem menos de 25 anos. Esta realidade demográfica, muitas vezes vista como um desafio, é na realidade um dos maiores activos estratégicos da região, desde que se invista com método e visão.",
 "Escolas bilingues (francês-português-inglês), centros de formação para os ofícios de amanhã (digital, energia, agroalimentar, turismo), universidades técnicas e plataformas ed-tech: o campo é vasto e ainda pouco estruturado. É um sector onde o impacto social se conjuga naturalmente com a rentabilidade a longo prazo.",
 ]
 ),
 },
 kpis: {
 title: p("Chiffres clés de l'éducation", "Education key figures", "Dados-chave da educação"),
 items: [
 { n: "45-60 %", l: p("Moins de 25 ans", "Under 25", "Menos de 25 anos"), d: p("Guinée-Bissau combinés.", "Guinea-Bissau combined.", "Guiné-Bissau combinadas.") },
 { n: "60 %", l: p("Alphabétisation adulte", "Adult literacy", "Alfabetização adulta"), d: p("Marge de progression significative, segment adulte à cibler.", "Significant progression margin, adult segment to target.", "Margem de progressão significativa, segmento adulto a visar.") },
 { n: "3", l: p("Langues stratégiques", "Strategic languages", "Línguas estratégicas"), d: p("Portugais (GW), français (Guinée-Bissau), anglais (CEDEAO).", "Portuguese (GW), French (Guinea-Bissau), English (ECOWAS).", "Português (GW), francês (Guinea-Bissau), inglês (CEDEAO).") },
 { n: "€ 250 M", l: p("Dépenses éduc. privées", "Private educ. spending", "Despesa priv. educação"), d: p("Estimation régionale annuelle.", "Regional annual estimate.", "Estimativa regional anual.") },
 { n: "Peu", l: p("Formations métiers structurées", "Structured vocational training", "Formações profissionais estruturadas"), d: p("Filières solaire, cajou, tourisme, numérique à créer.", "Solar, cashew, tourism, digital courses to create.", "Fileiras solar, caju, turismo, digital a criar.") },
 { n: "OMVG", l: p("Coopération régionale", "Regional cooperation", "Cooperação regional"), d: p("Programmes éducatifs transfrontaliers possibles.", "Cross-border educational programmes possible.", "Programas educativos transfronteiriços possíveis.") },
 ],
 sources: p(
 "Sources : UNESCO, ministère de l'Éducation Guinée-Bissau, Rectorat de données 2022-2025.",
 "Sources: UNESCO, Guinea-Bissau Ministry of Education, Rectorate of data 2022-2025.",
 "Fontes: UNESCO, Ministério da Educação da Guiné-Bissau, Reitoria de dados 2022-2025."
 ),
 },
 opportunites: {
 title: p("Segments d'investissement prioritaires", "Priority investment segments", "Segmentos de investimento prioritários"),
 intro: p(
 "Quatre segments à impact fort, avec des business models éprouvés ailleurs en Afrique de l'Ouest.",
 "Four high-impact segments with business models proven elsewhere in West Africa.",
 "Quatro segmentos de forte impacto com modelos de negócio comprovados noutros locais da África Ocidental."
 ),
 segments: [
 { h3: p("1. Écoles bilingues privées (K–12)", "1. Private bilingual schools (K–12)", "1. Escolas bilingues privadas (K–12)"),
 p: p("Français-portugais-anglais, standards internationaux. Ticket : 300 000 à 1 M€.", "French-Portuguese-English, international standards. Ticket: €300k to €1M.", "Francês-português-inglês, padrões internacionais. Ticket: 300 000 a 1 M€.") },
 { h3: p("2. Formation professionnelle technique", "2. Technical vocational training", "2. Formação profissional técnica"),
 p: p("Solaire, cajou, tourisme, numérique, hôtellerie. Ticket : 80 000 à 300 000 €.", "Solar, cashew, tourism, digital, hospitality. Ticket: €80k to €300k.", "Solar, caju, turismo, digital, hotelaria. Ticket: 80 000 a 300 000 €.") },
 { h3: p("3. Ed-tech mobile-first", "3. Mobile-first ed-tech", "3. Ed-tech mobile-first"),
 p: p("Cours en ligne trilingues, contenus courts, freemium. Ticket : 50 000 à 200 000 €.", "Trilingual online courses, short content, freemium. Ticket: €50k to €200k.", "Cursos online trilingues, conteúdos curtos, freemium. Ticket: 50 000 a 200 000 €.") },
 { h3: p("4. Résidences et campus universitaires", "4. Student residences and campuses", "4. Residências e campus universitários"),
 p: p("Adossé à Bissau, Bafatá. Ticket : 400 000 à 1,5 M€.", "Anchored in Bissau, Bafatá. Ticket: €400k to €1.5M.", "Ancorado em Bissau, Bafatá. Ticket: 400 000 a 1,5 M€.") },
 ],
 },
 defis: {
 title: p("Les défis à anticiper", "Challenges to anticipate", "Desafios a antecipar"),
 intro: p(
 "L'éducation est le secteur le plus exigeant en confiance et en durée.",
 "Education is the sector most demanding in trust and duration.",
 "A educação é o sector mais exigente em confiança e duração."
 ),
 items: p(
 [
 "Cadre réglementaire à sécuriser (agréments, homologations).",
 "Recrutement d'enseignants qualifiés, partenariats académiques indispensables.",
 "Solvabilité des familles à segmenter finement.",
 "Cycle d'investissement long (5-10 ans) avant maturité.",
 ],
 [
 "Regulatory framework to secure (accreditations, approvals).",
 "Recruitment of qualified teachers, academic partnerships indispensable.",
 "Family solvency to segment finely.",
 "Long investment cycle (5-10 years) before maturity.",
 ],
 [
 "Enquadramento regulamentar a garantir (autorizações, homologações).",
 "Recrutamento de professores qualificados, parcerias académicas indispensáveis.",
 "Solvência das famílias a segmentar finamente.",
 "Ciclo de investimento longo (5-10 anos) antes da maturidade.",
 ]
 ),
 closing: p(
 "Ce sont ces exigences mêmes qui construisent la réputation d'une école, et sa valeur patrimoniale.",
 "It is these very demands that build a school's reputation, and its patrimonial value.",
 "São estas mesmas exigências que constroem a reputação de uma escola, e o seu valor patrimonial."
 ),
 },
 pourquoi: {
 title: p("La Maison qui forme la relève.", "The House that trains the next generation.", "A Casa que forma a próxima geração."),
 paragraphs: p(
 [
 "NANDA SÁ Académie forme déjà des jeunes en leadership, entrepreneuriat, numérique et énergie. Nous connaissons les cadres académiques ouest-africains, les partenariats européens possibles, les foncerie éducatives disponibles à Canchungo et à Bafatá.",
 ],
 [
 "NANDA SÁ Académie already trains young people in leadership, entrepreneurship, digital and energy. We know West African academic frameworks, possible European partnerships, and available educational plots in Canchungo and Bafatá.",
 ],
 [
 "A NANDA SÁ Académie já forma jovens em liderança, empreendedorismo, digital e energia. Conhecemos os quadros académicos oeste-africanos, as parcerias europeias possíveis, os terrenos educativos disponíveis em Canchungo e Bafatá.",
 ]
 ),
 bullets: p(
 [
 "Étude d'implantation d'école ou centre",
 "Partenariats académiques internationaux",
 "Recrutement de corps enseignant",
 "Programmes bilingues et certifications",
 ],
 [
 "School or centre siting study",
 "International academic partnerships",
 "Teaching staff recruitment",
 "Bilingual programmes and certifications",
 ],
 [
 "Estudo de implantação de escola ou centro",
 "Parcerias académicas internacionais",
 "Recrutamento de corpo docente",
 "Programas bilingues e certificações",
 ]
 ),
 },
 download: {
 title: p("Télécharger la note « Éducation · Guinée-Bissau ».", "Download the brief « Education · Guinea-Bissau ».", "Descarregar a nota « Educação · Guiné-Bissau »."),
 body: p(
 "Note préparée par NANDA SÁ : chiffres clés, segments à structurer, cadre réglementaire, contacts utiles.",
 "Brief prepared by NANDA SÁ: key figures, segments to structure, regulatory framework, useful contacts.",
 "Nota preparada pela NANDA SÁ: dados-chave, segmentos a estruturar, enquadramento regulamentar, contactos úteis."
 ),
 pdfUrl: "/pdf/nanda-sa-note-education.pdf",
 pdfFilename: "nanda-sa-note-education.pdf",
 mailSubject: p("Téléchargement de la note « Éducation »", "Download of the brief « Education »", "Descarga da nota « Educação »"),
 mailBody: p(
 "Bonjour, je souhaite recevoir la note « Éducation · Guinée-Bissau ».",
 "Hello, I would like to receive the brief « Education · Guinea-Bissau ».",
 "Olá, gostaria de receber a nota « Educação · Guiné-Bissau »."
 ),
 },
 contact: {
 title: p("Parlons de votre projet éducatif.", "Let's talk about your educational project.", "Falemos do seu projecto educativo."),
 body: p(
 "Fondation, école, université, ONG, groupe scolaire, investisseur : décrivez votre intention, nous répondons personnellement.",
 "Foundation, school, university, NGO, school group, investor: describe your intention, we respond personally.",
 "Fundação, escola, universidade, ONG, grupo escolar, investidor: descreva a sua intenção, respondemos pessoalmente."
 ),
 quote: p(
 "On ne prépare pas l'avenir : on forme celles et ceux qui vont le construire.",
 "You do not prepare the future: you train those who will build it.",
 "Não se prepara o futuro: forma-se quem o vai construir."
 ),
 subject: p("Investir dans l'éducation en Guinée-Bissau", "Invest in education in Guinea-Bissau", "Investir na educação na Guiné-Bissau"),
 },
 ctas: ["Conseil"],
};

export default education;
